var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIntaroLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 244.375,
    height: 40.194,
    viewBox: "0 0 244.375 40.194",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo_intaro",
    "data-name": "logo intaro",
    transform: "translate(-1128.904 -1189.538)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_144",
    "data-name": "Group 144",
    transform: "translate(1128.904 1189.538)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "INTARO",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_120",
    "data-name": "Group 120",
    transform: "translate(8.135 13.188) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M0,0H26.94V8.126H6.847C3.065,8.126,0,4.488,0,0",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_121",
    "data-name": "Group 121",
    transform: "translate(71.366 13.109)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M9.671-21.466,7.707-19.26H-11.207V5.553h-8.507V-19.26H-37.384v-2.206Z",
    transform: "translate(37.384 21.466)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_122",
    "data-name": "Group 122",
    transform: "translate(109.288 13.109)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M5.211-21.466H3.177L-20.144,5.553h4.069l.488-.563L2.035-15.422,12.251-3.255h.054L19.7,5.553h8.287Z",
    transform: "translate(20.144 21.466)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_123",
    "data-name": "Group 123",
    transform: "translate(191.061 13.206)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M5.478,24.662a26.215,26.215,0,0,0,7.334-.926,16.522,16.522,0,0,0,5.351-2.567,10.851,10.851,0,0,0,3.3-3.916,11.1,11.1,0,0,0,1.114-4.948,10.426,10.426,0,0,0-4.409-8.692,16.456,16.456,0,0,0-5.351-2.487A27.35,27.35,0,0,0,5.478.24a28.112,28.112,0,0,0-7.432.887A16.114,16.114,0,0,0-7.33,3.614a10.5,10.5,0,0,0-3.245,3.823,10.9,10.9,0,0,0-1.09,4.869,11.3,11.3,0,0,0,1.09,4.948A10.7,10.7,0,0,0-7.33,21.169a16.169,16.169,0,0,0,5.376,2.567,26.943,26.943,0,0,0,7.432.926m0,1.3A48.792,48.792,0,0,1-5,24.887a34.369,34.369,0,0,1-8.473-2.937,18,18,0,0,1-5.648-4.339,8.154,8.154,0,0,1-2.056-5.3,7.944,7.944,0,0,1,2.056-5.213,17.555,17.555,0,0,1,5.648-4.233A35.6,35.6,0,0,1-5,.015,50.024,50.024,0,0,1,5.478-1.03,50.032,50.032,0,0,1,15.958.015a35.613,35.613,0,0,1,8.473,2.844,17.561,17.561,0,0,1,5.648,4.233,7.947,7.947,0,0,1,2.057,5.213,8.156,8.156,0,0,1-2.057,5.3,18,18,0,0,1-5.648,4.339,34.38,34.38,0,0,1-8.473,2.937,48.8,48.8,0,0,1-10.48,1.072",
    transform: "translate(21.178 1.03)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_124",
    "data-name": "Group 124",
    transform: "translate(20.091 13.109)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M7.21-21.466V1.73L-19.747-21.328h-8.127V5.553h8.126V-17.286L7.093,5.553l.117-.009v.009h8.507V-21.466Z",
    transform: "translate(27.873 21.466)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_125",
    "data-name": "Group 125",
    transform: "translate(150.651 13.109)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M4.123,3.256c6.349-.183,11.546-3.2,11.546-6.884,0-3.806-5.37-6.892-12-6.892H-15.938l1.827,2.206h9.2c5.236.2,9.412,1.526,11.3,3.34a2.81,2.81,0,0,1,1,1.991C7.385-1.5,5.826-.161,3.308.808a24.551,24.551,0,0,1-6.1,1.365c-.742.079-1.515.126-2.3.157L6.938,16.5h8.4",
    transform: "translate(15.938 10.521)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_126",
    "data-name": "Group 126",
    transform: "translate(0 10.419) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M0,0H10.419V8.145H8.145A8.145,8.145,0,0,1,0,0",
    fill: "#fff"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntaroLogo);
export default __webpack_public_path__ + "static/media/IntaroLogo.f8f497d6355ff22a8c72345cc2a4e7c0.svg";
export { ForwardRef as ReactComponent };